/**
 * SessionStorage handoff of TERMS+PRIVACY for OIDC **registration** start (G22).
 * Legal ticks are Registrace-only; login/sign-in never mounts them.
 * Do not teach org-picker carry for tenantless Google/Apple login.
 * Key is not put in the URL — restore into Register form state on mount.
 */

export const OIDC_START_CONSENTS_STORAGE_KEY = 'rpapp.oidc.startConsents';

export interface OidcStartConsentsCarry {
  readonly terms: boolean;
  readonly privacy: boolean;
}

function getSessionStorage(): Storage | null {
  if (typeof window === 'undefined' || !('sessionStorage' in window)) {
    return null;
  }
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function persistOidcStartConsents(consents: OidcStartConsentsCarry): void {
  const storage = getSessionStorage();
  if (storage === null) {
    return;
  }
  try {
    storage.setItem(
      OIDC_START_CONSENTS_STORAGE_KEY,
      JSON.stringify({
        terms: consents.terms === true,
        privacy: consents.privacy === true,
      }),
    );
  } catch {
    // private mode / quota — picker restore becomes best-effort
  }
}

export function readOidcStartConsents(): OidcStartConsentsCarry | null {
  const storage = getSessionStorage();
  if (storage === null) {
    return null;
  }
  try {
    const raw = storage.getItem(OIDC_START_CONSENTS_STORAGE_KEY);
    if (raw === null || raw.length === 0) {
      return null;
    }
    const parsed: unknown = JSON.parse(raw);
    if (typeof parsed !== 'object' || parsed === null) {
      return null;
    }
    const record = parsed as Record<string, unknown>;
    return {
      terms: record['terms'] === true,
      privacy: record['privacy'] === true,
    };
  } catch {
    return null;
  }
}

export function clearOidcStartConsents(): void {
  const storage = getSessionStorage();
  if (storage === null) {
    return;
  }
  try {
    storage.removeItem(OIDC_START_CONSENTS_STORAGE_KEY);
  } catch {
    // ignore
  }
}
